<template>
  <hm-content title="">
    <div class="table-panel flex  flex-end">
      <el-input
        clearable
        style="width: 200px"
        v-model.trim="searchCondition.keyword"
        placeholder="请输入雇员姓名"
        size="small"
        class="ipt mr20"
      ></el-input>
      <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.belongShopId"
          placeholder="请选择所属门店"
          filterable
        >
          <el-option
            :label="v.shopName"
            :value="v.shopId"
            :key="i"
            v-for="(v, i) in shopList.records"
          ></el-option>
        </el-select>
      <!-- <el-cascader
        v-model="searchCondition.wxshopCategoryId"
        :show-all-levels="false"
        size="small"
        class="mr10"
        :props="categoryFunc"
        clearable
        placeholder="请选择微店商品分类"
      ></el-cascader>
      <el-cascader
        v-model="searchCondition.attributeId"
        placeholder="请选择辅助属性"
        :show-all-levels="false"
        size="small"
        class="mr10"
        :props="attributeFunc"
        clearable
      ></el-cascader> -->
      <el-input
        clearable
        style="width: 120px"
        v-model.trim="searchCondition.minPrice"
        placeholder="总计佣金下限"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        style="width: 120px;"
        v-model.trim="searchCondition.maxPrice"
        placeholder="总计佣金上限"
        size="small"
        class="ipt mr20"
      ></el-input>

      <el-input
        clearable
        style="width: 100px"
        v-model.trim="searchCondition.minPrice"
        placeholder="已提现下限"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        style="width: 100px"
        v-model.trim="searchCondition.maxPrice"
        placeholder="已提现上限"
        size="small"
        class="ipt mr20"
      ></el-input>

      <el-input
        clearable
        style="width: 100px"
        v-model.trim="searchCondition.minPrice"
        placeholder="可提现下限"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        style="width: 100px"
        v-model.trim="searchCondition.maxPrice"
        placeholder="可提现上限"
        size="small"
        class="ipt mr10"
      ></el-input>

      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
    </div>

    <div class="table">
      <el-table
        @sort-change="sortChange"
        stripe
        border
        @selection-change="getChecked"
        ref="brandTable"
        :data="[]"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="雇员分销"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="所属门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiveAccount"
          label="下属推会员数"
        >
        </el-table-column>
        <el-table-column
          prop="shareOrderNum"
          header-align="center"
          align="center"
          label="分销总额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalSalesVolume"
          label="分销总订单"
        >
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="佣金详情" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="toDetails(scope.row)"
                >
                  <span class="hmicon icon-yongjinxiangqing blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="提现详情" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-daochubiaoge blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="1"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex  flex-end">
        <div class="flex text-right  flex-end">
          <el-input
            clearable
            style="width:150px;"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入雇员姓名/电话"
            size="small"
            class="ipt mr20"
          ></el-input>

          <el-input
            clearable
            v-model.trim="searchDialogCondition.minPrice"
            placeholder="指导价下限"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.maxPrice"
            placeholder="指导价上限"
            size="small"
            style="width: 100px"
            class="ipt mr20"
          ></el-input>

          <el-input
            clearable
            v-model.trim="searchDialogCondition.minPrice"
            placeholder="成交价下限"
            size="small"
            style="width: 100px"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            v-model.trim="searchDialogCondition.maxPrice"
            placeholder="成交价上限"
            size="small"
            style="width: 100px"
            class="ipt mr20"
          ></el-input>

          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr20"
            style="width: 300px"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="searchDialogCondition.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="选择开始日期"
            end-placeholder="选择结束日期"
          ></el-date-picker>
          <el-button type="primary" size="small" @click="searchGoods"
            >查询</el-button
          >
          <el-button
            type="info"
            size="small"
            @click="searchDialogCondition = {}"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          @selection-change="getChecked"
          @current-change="handleCurrentChange"
          highlight-current-row
          :data="wxShopList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            :index="index => index + (currentMicroPage - 1) * pageMicroSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="订单号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="雇员名称"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.spuAttributeValueList.join() }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="成交日期"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="指导价"
          >
            <template slot-scope="scope">
              <span class="rose">￥{{ scope.row.wxshopPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="成交价"
          >
            <template slot-scope="scope">
              <span class="rose">￥{{ scope.row.wxshopPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="商品明细"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            show-overflow-tooltip
            label="订单状态"
          >
            <template slot-scope="scope">
              <span class="rose">￥{{ scope.row.wxshopPrice }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="wxShopList.total"
          @current-change="pagingMicro"
          @size-change="handleSizeMicroChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentMicroPage"
        ></el-pagination>
      </div>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="报表导出设置"
      width="50%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleExport"
    >
      <span class="mr20">报表时间范围</span>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        style="width: 300px"
        size="small"
        class="mb20"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchDialogCondition.date"
        type="datetimerange"
        range-separator="至"
        start-placeholder="选择开始日期"
        end-placeholder="选择结束日期"
      ></el-date-picker>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="affirmExport"
          >确认</el-button
        >
        <el-button size="small" @click="dialogVisibleExport = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      searchCondition: {},
      searchDialogCondition: {},
      currentPage: 1,
      pageSize: 10,
      currentMicroPage: 1,
      pageMicroSize: 10,
      dialogVisibleGoods: false,
      dialogVisibleExport: false,
      checkedRow: []
    };
  },
  computed: mapGetters(["wxShopList","shopList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryMicroShopGoodsList();
    this.queryShopList();
  },
  methods: {
    queryList() {},
    queryShopList() {
      this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toDetails(row) {},
    edit(row) {},
    getChecked(selection) {
      this.checkedRow = selection;
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      searchDialogCondition.wxshopCategoryId = this.isArray(
        searchDialogCondition.wxshopCategoryId
      )
        ? searchDialogCondition.wxshopCategoryId[
            searchDialogCondition.wxshopCategoryId.length - 1
          ]
        : searchDialogCondition.wxshopCategoryId;

      searchDialogCondition.attributeId = this.isArray(
        searchDialogCondition.attributeId
      )
        ? searchDialogCondition.attributeId[
            searchDialogCondition.attributeId.length - 1
          ]
        : "";
      Object.assign(params, searchDialogCondition);
      return this.$store.dispatch("queryWxshopList", params);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    affirm() {
      if (this.currentRow) {
        this.dialogVisibleGoods = false;

        // let attr = this.currentRow.spuAttributeValueList.join();
        // let name = this.currentRow.wxshopSpuName;
        // this.ruleForm.memberPurchaseSkuName = `${name}【${attr}】`;
      } else {
        this.$message({
          message: "请选择商品！",
          type: "warning"
        });
      }
    },
    affirmExport() {},
    sortChange(sort) {
      //   this.sort = sort;
      //   this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
